import { Flex, Link, Box, Text } from '@chakra-ui/react';
import React from 'react';
import { Link as RouteLink } from 'react-router-dom';

import PrimaryButton from './buttons/primaryButton/primary-button';
import WarningButton from './buttons/warningButton/warning-button';

interface IFormSaveCancelProps {
    cancelButtonText?: string;
    saveButtonText?: string;
    cancelButtonRoute?: string;
    onRecordAdd: (e: React.SyntheticEvent) => void;
}

const FormFooter: React.FC<IFormSaveCancelProps> = ({ cancelButtonRoute, cancelButtonText, onRecordAdd, saveButtonText = 'Save' }) => (
    <Box position="sticky" bottom={0} bg="white" py={4} boxShadow="0px -2px 4px rgba(0, 0, 0, 0.1)" width="full">
        <Flex justifyContent="space-between" alignItems="center" px={6}>
            <Text color="teal.500" fontSize="sm" fontWeight="medium">
                Ready to save your changes or head back to the previous page?
            </Text>
            <Flex>
                <WarningButton ariaLabel="cancel" mr={2} variant="outline">
                    <Link as={RouteLink} to={cancelButtonRoute ?? '/'} _hover={{ textDecor: 'none' }}>
                        {cancelButtonText ?? 'Cancel'}
                    </Link>
                </WarningButton>
                <PrimaryButton mr={2} onClick={onRecordAdd} variant="outline">
                    {saveButtonText}
                </PrimaryButton>
            </Flex>
        </Flex>
    </Box>
);

export default FormFooter;
